import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortalOutlinedMailIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.66797 8C4.66797 6.89543 5.5634 6 6.66797 6H18.668C19.7726 6 20.668 6.89543 20.668 8V16C20.668 17.1046 19.7726 18 18.668 18H6.66797C5.5634 18 4.66797 17.1046 4.66797 16V8ZM6.66797 7C6.11569 7 5.66797 7.44772 5.66797 8V8.2169L12.668 12.4169L19.668 8.2169V8C19.668 7.44772 19.2203 7 18.668 7H6.66797ZM19.668 9.3831L14.9599 12.2079L19.668 15.1052V9.3831ZM19.6342 16.2586L13.9938 12.7876L12.668 13.5831L11.3421 12.7876L5.70173 16.2586C5.81571 16.6855 6.20512 17 6.66797 17H18.668C19.1308 17 19.5203 16.6855 19.6342 16.2586ZM5.66797 15.1052L10.376 12.2079L5.66797 9.3831V15.1052Z",
		fill: "#4B7987",
		stroke: "#4B7987",
		strokeWidth: .5
	})]
});
const ForwardRef = forwardRef(SvgPortalOutlinedMailIcon);
const Memo = memo(ForwardRef);
export default Memo;
